import { lazy } from "react";
import {usrPermission} from "../../config/userPermission";

const PartnersAll = lazy(() => import("./pages/PartnersAll"));

export const routes: any = [
    {
        path: "partner-and-sponsors",
        permission: usrPermission.partners.r,
        element: <PartnersAll />,
    },
];